import '../sass/single-fixture-dropdowns.scss';

(() => {
    const $templateParts = document.querySelectorAll('.single-fixture-dropdowns');

    if (!$templateParts) return;

    $templateParts.forEach($templatePart => {
        const $dropdowns = $templatePart.querySelectorAll('.single-fixture-dropdowns__dropdown');

        const initRaceDetails = () => {
            if (!$dropdowns) return;

            $dropdowns.forEach($dropdown => {
                new Details($dropdown);
            });
        }

        initRaceDetails();
    });
})();
